const PERCENTAGE_ROWS = ['Return on Assets', 'Operating Margin'];

export default PERCENTAGE_ROWS;
